import {
  compose,
  prop,
  defaultTo,
  cond,
  always,
  T,
  equals,
  evolve,
  pathOr,
  T as True
} from 'ramda'
import { unlessNull } from '../../common/functions'
import { currencyFormatter, formatUnixDate } from '../../common/functions/formatters'

const getValueAndFormatCurrency = compose(currencyFormatter('$0[.]00'), unlessNull(prop('value')))
const getMaxValueAndFormatCurrency = compose(defaultTo(''), unlessNull(x => ` - ${x}`), getValueAndFormatCurrency)
const displayAdditionalIncome = addIncome => (addIncome ? '(+)' : '')
const parsePayRateData = evolve({
  base_compensation: getValueAndFormatCurrency,
  base_compensation_max: getMaxValueAndFormatCurrency,
  additional_income: displayAdditionalIncome
})
const formatPayRate = schedule => ({
  base_compensation, // eslint-disable-line camelcase
  base_compensation_max, // eslint-disable-line camelcase
  additional_income // eslint-disable-line camelcase
}) => base_compensation !== '$0' || base_compensation_max ? `${base_compensation}${base_compensation_max}/${schedule} ${additional_income || ''}` : null // eslint-disable-line camelcase

const parseAndFormatPayRate = schedule => compose(formatPayRate(schedule), parsePayRateData)
const payScheduleEquals = schedule => compose(equals(schedule), prop('pay_schedule'))
const selectPayRate = cond([
  [payScheduleEquals('Weekly'), parseAndFormatPayRate('week')],
  [payScheduleEquals('Hourly'), parseAndFormatPayRate('hour')],
  [payScheduleEquals('Salary'), parseAndFormatPayRate('year')],
  [True, x => '']
])

const getJobCity = pathOr(null, ['facilities', 0, 'city'])
const getJobState = pathOr(null, ['facilities', 0, 'state'])

const totalCompensationValue = pathOr(null, ['total_compensation', 'value'])
const totalCompensationUnit = pathOr(null, ['total_compensation', 'unit'])

const getUnitConversion = cond([
  [equals('USD'), always('$')],
  [T, always('')]
])

export const getJobPay = selectPayRate
export const getJobTotalCompensation = (job) => {
  const value = totalCompensationValue(job)
  const unitConversion = getUnitConversion(totalCompensationUnit(job))
  return value ? `up to ${unitConversion}${value}` : null
}

export const getFacilityName = pathOr('', ['facilities', 0, 'facility_name'])

export const getFacilityLocation = (job) => {
  const city = getJobCity(job)
  const state = getJobState(job)
  return [city, state].filter(Boolean).join(', ')
}

export const getJobType = prop('employment_type')

export const getJobPostedDate = job => `Posted ${formatUnixDate(job.mgmt_job_go_live_datetime || job.created)}`

export const getJobDeadlineDate = job => `Deadline ${formatUnixDate(job.submission_deadline)}`
